<script setup lang="ts">
// Components
import { computed } from 'vue'
import { ShiftOfferStatus } from '../../../employee_shift/models/employeeShiftOffer'
import { DateTime } from 'luxon';

// Data
const { status, queueOrder = undefined, queueAt = undefined } = defineProps<{
  status: ShiftOfferStatus
  queueOrder?: number
  queueAt?: DateTime
}>()

const severity = computed(() => {
  switch (status) {
    case 'accepted':
      return 'success'
    case 'applied':
      return 'warn'
    case 'pending':
      return 'secondary'
    case 'rejected':
      return 'danger'
    case 'declined':
      return 'danger'
    case 'queued':
      return 'secondary'
    default:
      return 'secondary'
  }
})

const label = computed(() => {
  switch (status) {
    case 'accepted':
      return 'Accepted'
    case 'applied':
      return 'Applied'
    case 'pending':
      return 'Pending'
    case 'rejected':
      return 'Rejected'
    case 'declined':
      return 'Declined'
    case 'queued':
      return 'Queued' + (queueOrder ? ` (#${queueOrder})` : '') + (queueAt ? ` at ${queueAt.toLocaleString(DateTime.DATETIME_SHORT)}` : '')
    default:
      return 'Unknown'
  }
})
</script>

<template>
  <Tag
    :severity="severity"
    :value="label"
  />
</template>
